import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TranslocoModule } from '@ngneat/transloco';

import { IAreYouSureDialogData } from './are-you-sure-dialog.model';

@Component({
  standalone: true,
  selector: 'sandoz-are-you-sure',
  templateUrl: './are-you-sure.component.html',
  styleUrls: ['./are-you-sure.component.scss'],
  imports: [TranslocoModule, MatDialogModule, MatButtonModule],
})
export class AreYouSureComponent {
  protected readonly data = inject<IAreYouSureDialogData | null>(
    MAT_DIALOG_DATA,
  );
}
